export enum CategoryActionsTypes {
  "LIST_CATEGORY" = "LIST_CATEGORY"
}

export enum CategoryMutationsTypes {
  "SET_CATEGORY" = "SET_CATEGORY"
}

export enum CategoryGettersTypes {
  "CATEGORY_BY_ID" = "CATEGORY_BY_ID",
  "CATEGORY_ALL_ID" = "CATEGORY_ALL_ID"
}
